

export const forslerPartnerId = "7600089";
export const skovkortetPartnerId = "1737068";